import axios from './axios';

/**
 * Driver API Functions
 * Handles driver-related API calls for delivery boy management
 * Provides access to driver data for deposit and expense tracking
 */

// Get all delivery boys/drivers from backend API
export const getAllDrivers = async () => {
  const response = await axios.get('/admin/drivers');
  return response.data.data;
}; 